import React from 'react';
import { FiSearch, FiBell, FiMessageSquare, FiChevronDown, FiCpu, FiMenu } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = ({ isCollapsed, isMobile, toggleSidebar }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <nav
      className="navbar navbar-expand-lg sticky-top px-3 px-md-4 py-3"
      style={{
        marginLeft: isMobile ? '0' : (isCollapsed ? 'var(--sidebar-collapsed-width)' : 'var(--sidebar-width)'),
        backgroundColor: 'rgba(15, 23, 42, 0.8)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid var(--border-color)',
        transition: 'margin-left 0.3s ease',
        zIndex: 1030
      }}
    >
      <div className="container-fluid p-0">
        <div className="d-flex align-items-center gap-3">
          {isMobile && (
            <button
              onClick={toggleSidebar}
              className="btn text-white p-2 d-flex align-items-center justify-content-center bg-white bg-opacity-5 rounded-3 border-0"
            >
              <FiMenu size={20} />
            </button>
          )}

        </div>

        <div className="d-flex align-items-center gap-2 gap-md-3">
          <button className="btn btn-outline-primary btn-sm rounded-pill d-none d-sm-flex align-items-center gap-2 px-3">
            <FiCpu /> AI
          </button>

          <div className="vr mx-1 mx-md-2 bg-secondary opacity-25 d-none d-sm-block"></div>

          <div className="position-relative">
            <button className="btn btn-link text-white p-2">
              <FiBell size={20} />
              <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: '10px' }}>
                5+
              </span>
            </button>
          </div>

          <button className="btn btn-link text-white p-2 d-none d-md-block">
            <FiMessageSquare size={20} />
          </button>

          <div className="dropdown ms-1 ms-md-2">
            <button
              className="btn d-flex align-items-center gap-2 text-white border-0 dropdown-toggle p-1 p-md-2"
              type="button"
              data-bs-toggle="dropdown"
            >
              <img
                src={user?.avatar || 'https://i.pravatar.cc/150'}
                alt="Profile"
                className="rounded-circle border border-white border-opacity-10"
                width="32"
                height="32"
              />
              <div className="text-start d-none d-lg-block">
                <p className="mb-0 small fw-bold">{user?.name}</p>
                <p className="mb-0 text-muted" style={{ fontSize: '10px' }}>{user?.role}</p>
              </div>
              <FiChevronDown size={14} className="text-muted d-none d-md-block" />
            </button>
            <ul className="dropdown-menu dropdown-menu-dark dropdown-menu-end glass-card p-2 border-0 shadow-lg mt-2">
              <li><button onClick={() => navigate('/profile')} className="dropdown-item rounded-2 mb-1 py-2">My Profile</button></li>
              <li><button className="dropdown-item rounded-2 mb-1 py-2">Branch Settings</button></li>
              <li><hr className="dropdown-divider opacity-10" /></li>
              <li><button onClick={logout} className="dropdown-item rounded-2 text-danger py-2">Sign Out</button></li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
